module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 92);
/******/ })
/************************************************************************/
/******/ ({

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-utils");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/bridge");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/component");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/classCallCheck");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/createClass");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/getPrototypeOf");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/possibleConstructorReturn");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inherits");

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ account_bar_AccountBar; });

// EXTERNAL MODULE: external "@babel/runtime/helpers/classCallCheck"
var classCallCheck_ = __webpack_require__(4);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/createClass"
var createClass_ = __webpack_require__(5);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/possibleConstructorReturn"
var possibleConstructorReturn_ = __webpack_require__(8);
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/getPrototypeOf"
var getPrototypeOf_ = __webpack_require__(6);
var getPrototypeOf_default = /*#__PURE__*/__webpack_require__.n(getPrototypeOf_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/inherits"
var inherits_ = __webpack_require__(9);
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits_);

// EXTERNAL MODULE: external "@tencent/txv-utils"
var txv_utils_ = __webpack_require__(1);

// EXTERNAL MODULE: external "@tencent/txv-athena/lib/component"
var component_ = __webpack_require__(12);
var component_default = /*#__PURE__*/__webpack_require__.n(component_);

// EXTERNAL MODULE: external "@tencent/txv-athena/lib/bridge"
var bridge_ = __webpack_require__(11);
var bridge_default = /*#__PURE__*/__webpack_require__.n(bridge_);

// CONCATENATED MODULE: ./src/comps/business/account-bar/template.js
var tpl = function tpl() {
  return "\n  <div class=\"account-bar\">\n    <div class=\"account-btn\" data-type=\"qq\">\n      <i class=\"athena-icon-sm icon_qq_sm\">\n        <svg class=\"athena_svg_icon\" viewBox=\"0 0 16 16\" width=\"16\" height=\"16\">\n            <path d=\"M13.7 12.4s-.1.6-1.3-1.3c0 1.1-.5 2.1-1.3 2.8.4.1 1.2.4 1.2.8 0 0 .2.3-1.1.3 0 0-2.9.1-3-.1H8c-.1.2-3 .1-3 .1-1.3 0-1.1-.3-1.1-.3 0-.4.8-.7 1.2-.8-.8-.7-1.3-1.7-1.3-2.8-1.2 1.9-1.3 1.3-1.3 1.3-.4-1.6 1.4-5.5 1.4-5.5C3.7.5 8 1 8 1s4.4-.5 4.3 5.8c0 0 1.8 3.9 1.4 5.6z\"/>\n        </svg>\n      </i>\n      <span>QQ</span>\n    </div>\n    <div class=\"account-btn\" data-type=\"wx\">\n      <i class=\"athena-icon-sm icon_wechat_sm\">\n        <svg class=\"athena_svg_icon\" viewBox=\"0 0 16 16\" width=\"16\" height=\"16\">\n          <path d=\"M10.9 5.4h.2C10.7 2.9 8.4 1 5.6 1 2.5 1 0 3.3 0 6.1c0 1.6.8 3 2.1 4v.1c-.1.3-.5 1.8-.6 2 .2-.1 1.6-1 1.9-1.2h.2c.6.2 1.3.3 1.9.3h.2c-.1-.4-.2-.7-.2-1.1.1-2.7 2.5-4.8 5.4-4.8zM7.2 4.2c.1-.3.4-.5.7-.5.4 0 .7.4.7.8 0 .3-.2.6-.5.7-.2.1-.5.1-.7-.1-.2-.3-.3-.6-.2-.9zm-3.4 1c-.3.1-.6.1-.9-.1-.2-.3-.2-.6-.1-.9.1-.3.4-.5.7-.5.4 0 .7.4.7.8 0 .3-.2.6-.4.7z\"/>\n          <path d=\"M14.2 13.3c.9-.7 1.5-1.9 1.5-3.1 0-2.4-2.2-4.3-4.8-4.3s-4.8 1.9-4.8 4.3 2.2 4.3 4.8 4.3c.7 0 1.3-.1 2-.4.1 0 0 0 0 0l1.5 1-.2-1.8zm-5-4.1c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.2 0 .4.1.5.2s.2.3.2.5c0 .4-.4.7-.7.7zm3.5 0c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.2 0 .4.1.5.2.1.1.2.3.2.5 0 .4-.3.7-.7.7z\"/>\n        </svg>\n      </i>\n      <span>\u5FAE\u4FE1</span>\n    </div>\n  </div>\n";
};
/* harmony default export */ var template = (tpl);
// CONCATENATED MODULE: ./src/comps/business/account-bar/index.js





function _callSuper(t, o, e) { return o = getPrototypeOf_default()(o), possibleConstructorReturn_default()(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], getPrototypeOf_default()(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }




var account_bar_AccountBar = /*#__PURE__*/function (_Component) {
  function AccountBar(containerId, options) {
    var _this;
    classCallCheck_default()(this, AccountBar);
    _this = _callSuper(this, AccountBar, [containerId, options]);
    _this.eventHub = txv_utils_["EventHub"].createEvents(_this);
    _this.action();
    return _this;
  }
  inherits_default()(AccountBar, _Component);
  return createClass_default()(AccountBar, [{
    key: "render",
    value: function render() {
      return template();
    }
  }, {
    key: "action",
    value: function action() {
      var _this2 = this;
      bridge_default.a.getMainLoginType().then(function (res) {
        var type = res.result;
        if (type === 'qq' || type === 'wx') {
          _this2.$renderDom.find(".account-btn[data-type=".concat(type, "]"))[0].className += ' current';
        }
      });
      this.$renderDom.find('.account-btn').on('click', function (e) {
        var _e$currentTarget$data = e.currentTarget.dataset,
          dataset = _e$currentTarget$data === void 0 ? {} : _e$currentTarget$data;
        _this2.eventHub.fire('account-click', dataset.type);
      });
    }
  }]);
}(component_default.a);


/***/ })

/******/ })["default"];